import { ax } from 'src/client'
import {
  COMPANY_PRICING_ETR,
  PARTNER_PRICING_ETR,
  PRICING
} from './serviceURLs'

export function getPartnerPricingEtp(partnerId) {
  return ax.get(
    PRICING.replace(':partnerId', partnerId).replace(':product', 'etp')
  )
}

export function updatePartnerPricingEtp(partnerId, payload) {
  return ax.put(
    PRICING.replace(':partnerId', partnerId).replace(':product', 'etp'),
    { countries: payload }
  )
}

export function getPartnerPricingEtr(partnerId) {
  return ax.get(PARTNER_PRICING_ETR.replace(':id', partnerId))
}

export function updatePartnerPricingEtr(partnerId, payload) {
  return ax.put(PARTNER_PRICING_ETR.replace(':id', partnerId), payload)
}

export function getCompanyPricingEtr(companyId) {
  return ax.get(COMPANY_PRICING_ETR.replace(':id', companyId))
}

export function updateCompanyPricingEtr(companyId, payload) {
  return ax.put(COMPANY_PRICING_ETR.replace(':id', companyId), payload)
}
